var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InsightsGroupController = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _useInsightData2 = require("./useInsightData");
var InsightsGroupController = exports.InsightsGroupController = (0, _createClass2["default"])(function InsightsGroupController(init) {
  (0, _classCallCheck2["default"])(this, InsightsGroupController);
  (0, _defineProperty2["default"])(this, "useController", function () {
    var _useInsightData = (0, _useInsightData2.useInsightData)(),
      isUserDataLoading = _useInsightData.isLoading,
      insights = _useInsightData.insights;
    var isLoading = isUserDataLoading;
    return {
      isLoading: isLoading,
      insights: insights || undefined
    };
  });
  Object.assign(this, init);
});